import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiUser, FiExternalLink } from 'react-icons/fi';
import { format } from 'date-fns';

// Date formatting helper
function formatDisplayDate(value) {
  if (!value) return "Not set";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  const day = String(date.getDate()).padStart(2, "0");
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const weekdays = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];
  return `${day}-${months[date.getMonth()]}-${date.getFullYear()}, ${weekdays[date.getDay()]}`;
}

export default function LeadTable({ leads, onSelectLead }) {
  const getStatusBadge = (sent) => (
    <div className={`w-2 h-2 rounded-full ${sent ? 'bg-success shadow-[0_0_8px_rgba(16,185,129,0.5)]' : 'bg-slate-200'}`}></div>
  );

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full text-left border-collapse min-w-[900px]">
        <thead>
          <tr className="bg-slate-50/50 border-b border-border">
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide">Received Date</th>
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide">Identity</th>
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide">Message</th>
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide">Source</th>
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide text-center">Alerts</th>
            <th className="py-4 px-6 text-xs font-semibold text-muted uppercase tracking-wide text-right">Action</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {leads.map((lead) => (
            <tr key={lead.id} className="group hover:bg-slate-50/50 transition-all cursor-pointer" onClick={() => onSelectLead(lead)}>
              <td className="py-4 px-6">
                <div className="flex flex-col">
                  <span className="text-sm font-medium text-ink">{formatDisplayDate(lead.created_at)}</span>
                  <span className="text-xs text-muted mt-0.5">{format(new Date(lead.created_at), 'h:mm a')}</span>
                </div>
              </td>
              <td className="py-4 px-6">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 bg-primary/5 rounded-md flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                    <SafeIcon icon={FiUser} className="text-sm" />
                  </div>
                  <div className="flex flex-col overflow-hidden max-w-[180px]">
                    <span className="text-sm font-medium text-ink truncate">{lead.name || 'Anonymous'}</span>
                    <span className="text-xs text-muted truncate">{lead.email || 'No email'}</span>
                  </div>
                </div>
              </td>
              <td className="py-4 px-6">
                <p className="text-sm text-slate-600 max-w-[240px] truncate font-medium">"{lead.message || 'No message'}"</p>
              </td>
              <td className="py-4 px-6">
                <span className="px-2 py-1 bg-slate-100 text-muted rounded-md text-xs font-medium uppercase tracking-wide">
                  {lead.utm_source || 'Direct'}
                </span>
              </td>
              <td className="py-4 px-6">
                <div className="flex justify-center gap-1.5" title="Email / SMS Sent">
                  {getStatusBadge(lead.business_email_sent)}
                  {getStatusBadge(lead.customer_ack_sent)}
                  {getStatusBadge(lead.sms_sent)}
                </div>
              </td>
              <td className="py-4 px-6 text-right">
                <button className="inline-flex items-center gap-2 px-3 py-2 bg-slate-50 group-hover:bg-primary group-hover:text-white text-slate-700 rounded-md text-xs font-medium transition-all">
                  <SafeIcon icon={FiExternalLink} />
                  <span>View</span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}